import template from './adpToggler.html';
import controller from './adpToggler.controller';
import './adpToggler.less';

let adpTogglerComponent = {
  restrict: 'E',
  bindings: {
    ngModel: '<',
    listItemHeading: '<',
    timelineContextualMenuItems: '<',
  },
  transclude: {
    item: '?toggleItem',
    content: '?toggleContent'
  },
  template,
  controller
};

export default adpTogglerComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpToggler/adpToggler.component.js